var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccident(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 55,
    viewBox: "0 0 143 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.3 54.4h4.3c3.2 0 4.9-1.7 5-5l.1-7.3c1.9-2 2.4-4.6 2.3-7.3v-5c0-2.4-.8-4.5-2.5-6.1-1.3-1.2-2.7-2.1-3.9-3.1-1.6-3.8-3-7.5-4.7-11.2-2.6-5.6-7-9-13.3-9.2C112-.1 105.1 0 98.3 0a16 16 0 0 0-14.6 10.2l-4.2 10.6C75 23 73 26.3 73.5 31v4.4c0 2.2.4 4.3 1.7 6 .5.8.7 1.6.7 2.5v5.5c.3 3.3 1.8 5.3 5.4 5.2h3.8c3-.1 4.8-1.8 5-4.8l.1-4a496 496 0 0 1 36.1-.2l.2 4c.1 2.9 1.8 4.7 4.8 4.8Zm-5-34.4c-4.1.4-8 .3-12 .4H90.3c1-2.7 1.9-5.2 3-7.4.7-1.4 1.8-2.6 3.5-2.9 1.5-.3 3-.6 4.6-.6l15.2-.1c3.8-.2 6.1 1.4 7.3 4.7.7 2 1.6 3.7 2.5 5.9ZM87 27.9c2.2 1 5.2 4 5 6.7-.6 1-1.5 1.4-2.6 1.4h-4.5c-1.7 0-3-.9-3.5-2.5-.7-2-.4-3.9 1.1-5a4 4 0 0 1 4.5-.6Zm38 4.6a8.1 8.1 0 0 1 6.3-5c2.1-.4 3.8.8 4.4 3 .8 2.8-.1 4.7-3 5.1-2 .4-4 .3-6 .1-1.8-.2-2.5-1.6-1.8-3.2ZM71.7 39.4c-.8 4.8-10.4 5.9-10.4 5.9s1-13.6-14.4-14.5c-15.5-.9-15.6 15.4-15.6 15.4L0 44.4V19.7l28.1 1.6A42.5 42.5 0 0 0 0 4.7V0A62 62 0 0 1 14.5 3c8.3 3.2 24.4 18.8 24.4 18.8l11.9.5s4-2.2 4.1-2.6c.2-.5 5.2 4.4 5.2 4.4l7.7-.4 1 4.8 3.6.9s.2 5-.7 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2 39h.3c3.1.2 5.4 2.8 5.3 5.8-.2 3-2.6 5.2-5.6 5.2H46c-3.1-.2-5.5-2.8-5.3-5.8.2-3 2.6-5.2 5.6-5.2Zm0-5c-5.6 0-10.3 4.3-10.7 9.9a10.6 10.6 0 0 0 10 11l.7.1c5.6 0 10.3-4.3 10.6-9.9.4-5.8-4.1-10.8-10-11.1h-.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h143v55H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccident);
export default __webpack_public_path__ + "static/media/Accident.5194753bcac6d5f2ecf9ee69a50128b6.svg";
export { ForwardRef as ReactComponent };